import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './FinalCtaSection.css';

const FinalCtaSection = ({ title, highlighttext, subtitle }) => (
    <section className="bs-final-cta-section">
        <div className="bs-container">
            <div className="bs-final-cta-content">
                <h2 className="bs-cta-title">
                   {<> {title} <span className="bs-text-gold-gradient">{highlighttext} </span></>|| <>READY TO SCALE YOUR <span className="bs-text-gold-gradient">BUSINESS?</span></>}
                </h2>
                <p className="bs-cta-subtitle">
                    {subtitle || "Join the invitation-only network where quality work is rewarded. Stop chasing leads and start building your empire."}
                </p>
                <div className="bs-cta-btn-wrapper">
                    <Link to="/select-role" className="bs-btn-cta-pill">
                        Create Your Free Profile <FaArrowRight />
                    </Link>
                </div>
                <p className="bs-cta-note">No credit card required for trial.</p>
            </div>
        </div>
    </section>
);

export default FinalCtaSection;
